import styled from "styled-components";

export const NewTagFtueWrapper = styled.div(({ theme }) => ({
    marginLeft: theme.spacing.xxSmall,
}));
